const conversionMap = {
    "game-balance-update": "balance-update",
    "game-bet-update": "bet-update",
    "game-win-update": "win-update",
    "game-settings-changed": "settings-changed",
    "game-error-message": "error-message",
    "game-exit": "exit-game",
    "game-goto-game": "goto-game",
    "pause-resume": "pause-resumed"
};
export const convertLegacyFeimEvent = (event) => {
    var _a;
    return (_a = conversionMap[event]) !== null && _a !== void 0 ? _a : event;
};
